<template>
  <div class="building">
    <b-navbar type="dark" variant="dark" fixed="top" toggleable="sm">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home" active> 🏢 </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item @click="$router.push('/maps')"><b-icon-map></b-icon-map> Map </b-nav-item>
          <b-nav-item active><b-icon-building></b-icon-building> Building </b-nav-item>
          <b-nav-item @click="$router.push('/data-warehouse')"><b-icon-file-earmark></b-icon-file-earmark> Data Warehouse </b-nav-item>
          <b-nav-item @click="$router.push('/reports')"><b-icon-newspaper></b-icon-newspaper> Reports </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout()">
            <b-icon-box-arrow-left></b-icon-box-arrow-left>
            Logout {{username}}
            <b-avatar class="mr-3" size="1.3em">
              <v-gravatar :size="100" default-img="retro" :email="username" />
            </b-avatar>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <main role="main" class="ml-sm-auto px-4">

      <div v-if="!building">
        <b-alert class="container" show variant="info">💡 Either we have no information on this building or you did not select a building on the map</b-alert>
      </div>
      <b-container fluid>
        <b-row>
          <b-col cols="9">
            <svg ref="floorPlan" width="100%" :height="height" class="floorpic">
              <g v-if="floor">
                <g v-if="devexp">
                  <!-- <image v-if="heatMap" :href="BUILDING_IMAGE_PATH + floor.heatmap" x="0" y="0" width="100%" /> -->
                  <image v-if="heatMap" :href="BUILDING_IMAGE_PATH + floor.heatmap" width="100%" max-height="850"/>
                  <!-- <image v-else :href="BUILDING_IMAGE_PATH + floor.map" x="0" y="0" width="100%" /> -->
                  <image v-else :href="BUILDING_IMAGE_PATH + floor.image" width="100%" max-height="850"/>
                </g>
                <g v-else>
                  <!-- <image v-if="floor.map" :href="BUILDING_IMAGE_PATH + floor.map" x="0" y="0" width="100%" /> -->
                   <image v-if="floor.image" :alt="BUILDING_IMAGE_PATH + floor.image" :href="BUILDING_IMAGE_PATH + floor.image" width="100%" max-height="850"/>
                </g>
                <g>
                  <circle v-for="(ap, index) in floor.ap" :key="'ap' + index"
                    :cx="x(ap.x)"
                    :cy="y(ap.y)"
                    r="3"
                    class="ap"
                  />
                  <circle v-for="(ap, index) in floor.ap" :key="'ap-density' + index"
                    :cx="x(ap.x)"
                    :cy="y(ap.y)"
                    :r="Math.floor(Math.random() * 30 + 5)"
                    class="ap-density"
                  />
                  <text v-for = "(ap, index) in floor.ap" :key = "'ap-name' + index"
                    :x="x(ap.x) + 5"
                    :y="y(ap.y) + 8"
                  >{{ap.name}}</text>
                </g>
              </g>
            </svg>
          </b-col>

          <b-col style="background-color: white">
            <div v-if="building">
              <h3>{{ building.properties.name }}</h3>
              <div class="text-left" v-for="(fl, index) in building.properties.floors" :key="index">
                <b-btn :variant="floor === fl ? 'warning' : 'info'" class="mb-2 w-100" style="border-radius: 4px; color: white;" @click="setFloor(fl)">{{fl.name}}</b-btn>
              </div>

              <b-checkbox v-if="devexp" v-model="heatMap" @change="heatMap = !heatMap" style="display: inline" switch><b>Heatmap</b></b-checkbox>

              <div><img src="legend.svg"/></div>
              <div id="vegaEmbed"></div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import Gravatar from "vue-gravatar";
import * as d3 from "d3";

Vue.component("v-gravatar", Gravatar);

import { IconsPlugin } from "bootstrap-vue";
Vue.use(IconsPlugin);

import vegaEmbed from "vega-embed";

export default {
  name: "Building",
  data: function () {
    return {
      building: null,
      floor: null,
      hex: ["#C34A2C", "#E8A317", "#4AA02C"],
      heatMap: false,
      // BUILDING_IMAGE_PATH: process.env.BASE_URL + process.env.VUE_APP_BUILDING_IMAGE_DIR,
      BUILDING_IMAGE_PATH: process.env.VUE_APP_SITE_DATA,
      devexp: false,
      width: "100%",
      height: 200,
      size: 800
    };
  },
  methods: {
    logout() {
      this.$router.push("/logout");
    },
    x() { return 1; },
    y() { return 1; },
    setFloor(fl) {
      let size = this.size;
      if (this.$refs.floorPlan) {
        size = this.$refs.floorPlan.clientWidth;
        this.width = size;
        this.height = this.y(size);
      }
      this.floor = fl;
      this.x = d3.scaleLinear()
        .domain([0, this.floor.width])
        .range([0, size]);

      this.y = d3.scaleLinear()
        .domain([0, this.floor.height])
        .range([0, this.floor.height / this.floor.width * size]);

      this.width = size;
      this.height = this.y(this.floor.height);
    },
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    },
  },
  mounted() {
    if (!this.$store.state.user) {
      this.$router.push("/about");
    }

    this.devexp = this.$store.state.devexp;
    this.building = this.$store.state.building;

    if (this.building) {
      //sort floors n → 0
      this.building.properties.floors.sort((a, b) => {  
        let anum = a.name.split(' ').pop();
        anum = isNaN(anum) ? 0 : +anum;

        let bnum = b.name.split(' ').pop();
        bnum = isNaN(bnum) ? 0 : +bnum;
        
        return ((anum > bnum) ? -1 : 1); 
      });
      
      //set default to 1st floor; should be the one with most density
      let x = this.building.properties.floors.length > 1 ? this.building.properties.floors.length - 2 : 0;
      this.setFloor(this.building.properties.floors[x]);
    
      var barPlotSpec = {
        $schema: "https://vega.github.io/schema/vega-lite/v4.json",
        title: "Floor density",
        data: {
          values: [
            { floor: "Floor 5", counts: 5 },
            { floor: "Floor 4", counts: 17 },
            { floor: "Floor 3", counts: 28 },
            { floor: "Floor 2", counts: 25 },
            { floor: "Floor 1", counts: 15 },
            { floor: "Basement", counts: 10 },
          ],
        },
        width: "140",
        mark: { type: "bar" },
        encoding: {
          color: { value: "#FFA500" },
          y: { field: "floor", type: "ordinal", sort: "descending" },
          x: { field: "counts", type: "quantitative" },
        },
      };

      window.onresize = () => {
        if (this.floor) {
          this.setFloor(this.floor);
        }
      }

      vegaEmbed("#vegaEmbed", barPlotSpec);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
main {
  margin-bottom: 4.5rem;
  margin-top: 68px;
  text-align: center;
}

h1,
h2,
h3 {
  color: #990000;
}
.app-icon {
  width: 32px;
  padding: 2px;
}
.title {
  align-content: center;
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 250px;
}

.floorpic {
  background-color: #FFCC00;
}

circle.ap-density {
  fill-opacity: 0.5;
  fill: #86bced;
}

circle.ap {
  fill: red;
}
</style>
